import { gql } from "@apollo/client";

export const GET_SUBSCRIPTION_CREDIT_AMOUNT = gql`
  query getSubscriptionCreditNoteAmount($bookingId: String!, $newEndDate: String!) {
    getSubscriptionCreditNoteAmount(bookingId: $bookingId, newEndDate: $newEndDate)
  }
`;
